/**
 *
 * SubmitError
 * Shown when saving a form failed, so a failed request is not silent.
 *
 */

import React from 'react';
import { Alert } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

function SubmitError() {
  return (
    <Alert bsStyle="danger">
      <FormattedMessage {...messages.message} />
    </Alert>
  );
}

export default SubmitError;
